import { merge, isFinite } from "lodash";
import queryString from "query-string";

import { Language, IQueryProps, IAppConfig, AppType, PageType } from "../types/global-type";

export const getAppType = (appTypeStr: string): AppType => {
  if (appTypeStr === "chart") {
    return AppType.CHART;
  }
  return AppType.AGGREGATE;
};

const getPageType = (): PageType => {
  const pathname = window.location.pathname;
  const appTypeStr = pathname.split("/")[2];

  if (appTypeStr === "edit") {
    return PageType.EDIT;
  }
  return PageType.VIEW;
};

// 处理 query
export const getQuery = (): IQueryProps => {
  const query = queryString.parse(window.location.search);
  const result = merge(query);
  result.hasPermission = query.hasPermission === "true";
  result.isExpand = query.isExpand === "true";
  result.locale = result.locale || Language.zh;
  result.shareUserId = query.shareUserId;
  // result.appType = getAppType();
  result.form = getPageType();
  return result;
};

export const convertValueStringToObject = (str: string): IAppConfig => {
  const value = JSON.parse(str) as IAppConfig;
  return value;
};

export const safeNumber = (value: any, def: number) => {
  if (value === 0 || value === "0") return 0;
  const val = Number(value);

  return !isFinite(val) || val < 0 ? def : val;
};
